import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { IconButton, Tooltip } from "@material-ui/core";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(0.5),
		flexShrink: 0
	},
	iconButton: {
		color: theme.palette.brand
	},
	iconButtonActive: {
		backgroundColor: theme.palette.highlight,
		color: theme.palette.brand,
		"&:hover": {
			backgroundColor: "#c1c72c"
		}
	}
}));

const PageHeaderListActions = ({
	showFilters,
	onToggleFilters,
	searchShowLabel = "Show search filters",
	searchHideLabel = "Hide search filters",
	showCollapseToggle = false,
	useCollapsedView = true,
	onToggleCollapsedView,
	collapseExpandLabel = "Expand all",
	collapseCollapseLabel = "Collapse all"
}) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Tooltip title={showFilters ? searchHideLabel : searchShowLabel}>
				<IconButton
					className={showFilters ? classes.iconButtonActive : classes.iconButton}
					onClick={onToggleFilters}
					size="small"
					aria-label={showFilters ? searchHideLabel : searchShowLabel}
				>
					<SearchOutlinedIcon />
				</IconButton>
			</Tooltip>
			{showCollapseToggle && onToggleCollapsedView && (
				<Tooltip title={useCollapsedView ? collapseExpandLabel : collapseCollapseLabel}>
					<IconButton
						className={!useCollapsedView ? classes.iconButtonActive : classes.iconButton}
						onClick={onToggleCollapsedView}
						size="small"
						aria-label={useCollapsedView ? collapseExpandLabel : collapseCollapseLabel}
					>
						<UnfoldMoreIcon
							style={{
								transform: useCollapsedView ? "rotate(0deg)" : "rotate(180deg)"
							}}
						/>
					</IconButton>
				</Tooltip>
			)}
		</div>
	);
};

PageHeaderListActions.propTypes = {
	showFilters: PropTypes.bool.isRequired,
	onToggleFilters: PropTypes.func.isRequired,
	searchShowLabel: PropTypes.string,
	searchHideLabel: PropTypes.string,
	showCollapseToggle: PropTypes.bool,
	useCollapsedView: PropTypes.bool,
	onToggleCollapsedView: PropTypes.func,
	collapseExpandLabel: PropTypes.string,
	collapseCollapseLabel: PropTypes.string
};

export default PageHeaderListActions;
